// @ai-generated 2026-09-30T14:52:11+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function formatFileSize(bytes: number): string {
    const kilobytes = bytes > 0 ? Math.max(1, Math.round(bytes / 1024)) : 0;
    if (kilobytes < 1024) {
        return `${kilobytes.toLocaleString('de-DE')} KB`;
    }

    return `${(bytes / MEGABYTE).toLocaleString('de-DE', { maximumFractionDigits: 1 })} MB`;
}

const MEGABYTE = 1024 * 1024;
